import {IUser} from '../Constants/Interfaces';
import {RootState} from '../Redux/store';


export function isUserId(id: string): boolean {
    return id.startsWith('0x');
}


export function createUserInstance(data: Partial<IUser>): IUser {
    return {
        uid: '',
        name: 'Guest',
        buddies: [],
        online: false,
        timestamp: 0,
        blacklist: [],
        avatar: {face: '', face128: '', face256: '', body: ''},
        pm_addresses: [],
        currentlyOn: 'metaverse',
        ...data,
    };
}


export interface IUsers {
    my: IUser;
    all: IUser[];
    buddies: string[];
    blacklist: string[];
    addresses: string[];
}


export function parseUsers(state: RootState): IUsers {
    const myId = state.auth;
    const usersMap = state.users.data;

    const allUsersArray = Object.values(usersMap);

    let result: IUsers = {
        all: allUsersArray,
        buddies: [],
        blacklist: [],
        addresses: [],
        my: createUserInstance({}),
    };

    if (!myId) {
        return result;
    }
    else {
        const myUserData = usersMap[myId] ? usersMap[myId] : result.my;
        if (myUserData.pm_addresses) {
            result.addresses = myUserData.pm_addresses;
        }
        result.my = myUserData;
        result.buddies = myUserData.buddies;
        result.blacklist = myUserData.blacklist;
    }

    return result;
}
